export default "__VITE_ASSET__BWB9RPIc__"